const eventDirection = (param, province, city, mode) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `branch_petunjuk_arah_button`,
      eventCategory: `localized landing page`,
      eventAction: `click on petunjuk arah`,
      eventLabel: `branch page - ${mode}`,
      cabangBooking: `${province?.toLowerCase()} - ${city?.toLowerCase()} - ${param?.toLowerCase()}`,
    });
  }
};
export default eventDirection;
